import Vue from 'vue'
import VueRouter, {RouteConfig} from 'vue-router'
import LogInView from '@/views/LogInView.vue'
import DevicesView from '@/views/DevicesView.vue'
import OverviewView from '@/views/overview/OverviewView.vue'
import ViewDeviceView from '@/views/ViewDeviceView.vue'
import UsersView from '@/views/UsersView.vue'
import DeviceGroupsView from '@/views/DeviceGroupsView.vue'
import PacketsView from '@/views/PacketsView.vue'
import EventsView from '@/views/EventsView.vue'
import {AppStore} from '@/store'
import {ROLE_ADMIN} from '@/models/User'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
    // COMMON
    {
        path: '/log-in',
        name: 'log-in',
        component: LogInView,
        meta: {isAnonymous: true},
    },
    {
        path: '/',
        name: 'main',
        component: OverviewView,
    },
    {
        path: '/overview',
        name: 'overview',
        component: OverviewView,
    },

    // DEVICE GROUPS
    {
        path: '/device-groups',
        name: 'device-groups-list',
        component: DeviceGroupsView,
        meta: {role: ROLE_ADMIN},
    },
    {
        path: '/device-groups/create',
        name: 'device-groups-create',
        component: DeviceGroupsView,
        props: {isCreating: true},
        meta: {role: ROLE_ADMIN},
    },
    {
        path: '/device-groups/edit/:id',
        name: 'device-groups-edit',
        component: DeviceGroupsView,
        meta: {role: ROLE_ADMIN},
    },

    // DEVICES
    {
        path: '/devices',
        name: 'devices-list',
        component: DevicesView,
        meta: {role: ROLE_ADMIN},
    },
    {
        path: '/devices/create',
        name: 'devices-create',
        component: DevicesView,
        props: {isCreating: true},
        meta: {role: ROLE_ADMIN},
    },
    {
        path: '/devices/edit/:id',
        name: 'devices-edit',
        component: DevicesView,
        meta: {role: ROLE_ADMIN},
    },
    {
        path: '/devices/view/:id',
        name: 'devices-view',
        component: ViewDeviceView,
    },

    // PACKETS
    {
        path: '/packets',
        name: 'packets-list',
        component: PacketsView,
        meta: {role: ROLE_ADMIN},
    },

    // EVENTS
    {
        path: '/events',
        name: 'events-list',
        component: EventsView,
    },

    // USERS
    {
        path: '/users',
        name: 'users-list',
        component: UsersView,
        meta: {role: ROLE_ADMIN},
    },
    {
        path: '/users/create',
        name: 'users-create',
        component: UsersView,
        props: {isCreating: true},
        meta: {role: ROLE_ADMIN},
    },
    {
        path: '/users/edit/:id',
        name: 'users-edit',
        component: UsersView,
        meta: {role: ROLE_ADMIN},
    },
]

export default function createRouter(store: AppStore) {
    const router = new VueRouter({
        routes,
    })

    router.beforeEach((to, from, next) => {
        if (to.matched.some(record => !record.meta.isAnonymous)) {
            if (!store.state.user) {
                next({
                    name: 'log-in',
                    query: { redirect: to.fullPath },
                })
                return
            }
            if (to.matched.some(record => record.meta.role && record.meta.role != store.state.user?.role )) {
                next({name: 'main'})
                return
            }
        }

        next()
    })

    return router
}
